/* Calmy PDP - gallery, variants, sticky ATC, size guide. */
(function () {
  /* Editable wording. Sources: Theme settings > "Text: ..." groups,
     serialised by snippets/calmy-strings.liquid. The second argument is
     the wording this file shipped with and is used when the snippet is
     absent or the setting is blank. */
  var CT = function (k, f) { return window.CalmyT ? window.CalmyT(k, f) : f; };

  'use strict';

  function money(cents, format) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, n);
  }

  function initGallery(root) {
    /* Intentionally empty. The gallery - its track, its dots, its viewer and
       its __goToMedia - is assets/calmy-gallery.js now. This stub stays because
       boot() below still calls it; removing the call as well would be the same
       change in two places. */
    return root;
  }

  /* ---------- Variants ----------
     The variant is decided by the option pickers and by nothing else. There
     used to be a second input here - the Single / Duo / Trio tier radios, which
     named a variant of their own and won over the pickers - and it is gone with
     the rest of the custom bundle selector. Bundling belongs to the Kaching
     Bundles app now, and a theme that also rewrote the variant and the quantity
     behind its back could only fight it.

     The quantity is one. It is not read from anything, and nothing in this file
     multiplies a price. */
  function initProduct(section) {
    var dataEl = section.querySelector('[data-calmy-variants]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var fmt = data.money_format;
    var gallery = section.querySelector('[data-cgal]');
    var form = section.querySelector('form[data-calmy-form]');
    var idInput = section.querySelector('[data-calmy-id]');
    var qtyInput = section.querySelector('[data-calmy-qty-input]');
    var priceEl = section.querySelector('[data-calmy-price]');
    var stickyPrice = section.querySelector('[data-calmy-sticky-price]');
    var inputs = section.querySelectorAll('[data-calmy-opt]');
    var labels = section.querySelectorAll('[data-calmy-optlabel]');
    var lowEl = section.querySelector('[data-calmy-low]');
    var lowText = section.querySelector('[data-calmy-low-text]');
    var lowMax = parseInt(section.dataset.lowMax, 10) || 0;
    var lowTpl = section.dataset.lowText || 'Only [n] left in stock';

    /* Is the bundles app showing an offer for this product right now?

       Detected from its own rendered elements and its own initialised flag -
       both real, both observed on the page - rather than from any API, because
       the app publishes none for this. kachingBundlesInitialized alone is not
       enough: it is set to true even when the app decides this product has no
       offer to show, so the deal block itself has to be present. */
    function bundlesActive() {
      return !!document.querySelector('kaching-bundles-block, kaching-bundles-bar, kaching-bundle, kaching-bundle-deals');
    }

    /* One. The cart line for this form is a single unit of the selected
       variant; anything that adds more than one is the bundles app's own
       add-to-cart handling, not this. */
    function currentQty() {
      /* Read the field rather than assume one. The bundles app writes the
         selected offer's quantity into it; hardcoding 1 here is what made the
         cart receive a single ring no matter which offer was chosen. */
      var n = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    function selected() {
      var out = [];
      inputs.forEach(function (i) { if (i.checked) out[parseInt(i.dataset.calmyOpt, 10)] = i.value; });
      return out;
    }

    function match(sel) {
      return variants.filter(function (v) {
        for (var i = 0; i < sel.length; i++) { if (sel[i] && v.options[i] !== sel[i]) return false; }
        return true;
      })[0];
    }

    function render(isInitial) {
      var sel = selected();
      var v = match(sel) || variants[0];

      if (!v) return;
      var qty = currentQty();

      labels.forEach(function (l) {
        var idx = parseInt(l.dataset.calmyOptlabel, 10);
        if (sel[idx]) l.textContent = sel[idx];
      });

      if (idInput) idInput.value = v.id;
      if (qtyInput) qtyInput.value = qty;

      var onSale = !!(v.compare_at_price && v.compare_at_price > v.price);
      if (priceEl) {
        /* Update the NODES, never innerHTML on the row.

           Rebuilding the row wrote back only the price and the struck-through
           figure, so every variant change silently deleted whatever else the
           template had put there — it is rendered from section settings the
           script cannot see, and once overwritten it never came back until
           reload. It also rebuilt them in the old order and without the
           classes the markup now carries. (The note that exposed this was the
           old "incl. VAT" span, since removed; the rule outlives it, and it is
           also why removing that span needs no change here.)

           Reaching for the individual elements leaves anything the template
           put in this row alone by construction, whatever it is. */
        var nowEl = priceEl.querySelector('.cinfo__now');
        if (!nowEl) {
          nowEl = document.createElement('span');
          nowEl.className = 'cinfo__now';
          priceEl.prepend(nowEl);
        }
        nowEl.textContent = money(v.price, fmt);

        var delEl = priceEl.querySelector('del');
        if (onSale) {
          if (!delEl) {
            delEl = document.createElement('del');
            priceEl.insertBefore(delEl, nowEl);
          }
          delEl.innerHTML = '<span class="calmy-sr">Regular price </span>' + money(v.compare_at_price, fmt);
        } else if (delEl) {
          delEl.remove();
        }

        /* ONE BADGE, AND IT IS RECALCULATED EVERY TIME.

           The row used to carry a "Sale" pill this script kept alive and a
           "Save $12.00" pill it never touched at all - so switching to a
           variant with a different discount left the old saving printed
           beside the new price. The percentage is worked out here from the
           variant that is actually selected, with the same arithmetic the
           Liquid uses, so the two can never disagree. */
        var offEl = priceEl.querySelector('.cinfo__off');
        var pct = onSale ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) : 0;
        if (onSale && pct > 0) {
          if (!offEl) {
            offEl = document.createElement('span');
            offEl.className = 'cinfo__off';
            offEl.setAttribute('data-calmy-off', '');
            nowEl.after(offEl);
          }
          offEl.textContent = (priceEl.dataset.offLabel || '[n]% OFF').replace('[n]', pct);
        } else if (offEl) {
          offEl.remove();
        }

        priceEl.classList.toggle('cinfo__price--sale', onSale);
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price * qty, fmt);

      /* TIER CARDS NO LONGER CARRY A PRICE THIS SCRIPT CAN CHANGE.

         Each card is a variant, and its price is printed by Liquid from that
         variant. There is nothing here to recompute — which is the point. The
         old block multiplied the selected variant's price by the card's
         quantity and applied a percentage typed into the theme, so a card
         could quote a total the cart would not honour, and switching finish
         rewrote all three cards to the new finish's arithmetic.

         What remains is only the low-stock line, which is a fact about the
         variant that is actually selected and therefore does have to follow it. */
      if (lowEl) {
        var inv = typeof v.inventory === 'number' ? v.inventory : null;
        var tracked = !!v.tracked;
        /* Above zero AND at or below the threshold. At zero the product is
           sold out and the sold-out path says so; "only 0 left" is not
           urgency, it is a bug. Untracked inventory reports zero, which is
           why the lower bound is not optional. */
        var show = lowMax > 0 && tracked && inv !== null && inv > 0 && inv <= lowMax;
        lowEl.hidden = !show;
        if (show && lowText) lowText.textContent = lowTpl.replace('[n]', inv);
      }

      section.querySelectorAll('[data-calmy-atc]').forEach(function (b) {
        b.disabled = !v.available;
        /* Through the helper, not textContent: this button is the marquee
           component and holds five copies of its label. Assigning textContent
           would replace the whole track with one bare word. */
        var setLabel = (window.Calmy && window.Calmy.setButtonLabel)
          || function (el, s) { el.textContent = s; };

        /* THE PARTS, WHERE THE BUTTON HAS THEM.

           The product page's button holds its label as icon + words + price,
           each in its own element, so only the words and the figure are
           rewritten and the cart icon beside them is never touched. Writing
           the whole label - which is what setButtonLabel does - would have
           deleted the SVG on the first variant change.

           The sticky bar's button has no parts and is not given any, so it
           keeps the old whole-label path. Nothing here assumes which kind of
           button it has. */
        var parts = b.querySelectorAll('[data-calmy-atc-text]');
        function setParts(words, priceText) {
          b.querySelectorAll('[data-calmy-atc-text]').forEach(function (el) { el.textContent = words; });
          b.querySelectorAll('[data-calmy-atc-price]').forEach(function (el) {
            el.textContent = priceText || '';
            el.hidden = !priceText;
          });
          b.querySelectorAll('[data-calmy-atc-sep]').forEach(function (el) { el.hidden = !priceText; });
          var sr = b.querySelector('.calmy-sr');
          if (sr) sr.textContent = priceText ? words + ' \u00B7 ' + priceText : words;
        }

        if (!v.available) {
          /* Sold out keeps the icon and drops the price: the separator and the
             figure are hidden rather than left showing a price for something
             that cannot be bought. */
          if (parts.length) setParts(b.dataset.labelSold || 'Sold out', '');
          else setLabel(b, b.dataset.labelSold || 'Sold out');
          return;
        }
        var label = b.dataset.labelDefault || 'Add to cart';
        /* Middle dot, matching every other place a label is joined to a
           price. This was an escaped \u2014 rather than a literal character,
           which is why the sweep for em dashes did not see it — it renders as
           one all the same. */
        /* THE PRICE IS THE SELECTED VARIANT'S, ALWAYS.

           This used to be suppressed whenever the Kaching Bundles deal block
           was on the page, on the reasoning that the figure a shopper is
           looking at is then the bundle total and this button knows only a
           unit price. The block is on EVERY product page in this store, so in
           practice the price never survived the first variant change - while
           Liquid rendered it on first paint regardless, which left the server
           and the script disagreeing about the same button.

           They agree now, and both print the SELECTED VARIANT'S OWN PRICE.
           Not price x quantity: the bundles app writes its offer quantity into
           the form field, so the multiplied figure came out as $89.90 beside a
           $44.95 variant on first load - a number that is neither the unit
           price Liquid had just rendered nor a total this button is
           responsible for.

           If the bundle total is wanted here instead, the app has its own
           supported switch for it - showTotalPriceInAddToCartButton, a setting
           in the app's admin - and the theme should not guess at the figure. */
        var priceText = b.dataset.showPrice === 'true' ? money(v.price, fmt) : '';
        if (parts.length) { setParts(label, priceText); return; }
        if (priceText) label += ' \u00B7 ' + priceText;
        setLabel(b, label);
      });

      if (!isInitial && v.media_id && gallery && gallery.__goToMedia) {
        gallery.__goToMedia(String(v.media_id));
      }
      if (!isInitial && window.history && window.history.replaceState && data.url) {
        window.history.replaceState({}, '', data.url + '?variant=' + v.id);
      }
    }

    inputs.forEach(function (i) { i.addEventListener('change', function () { render(false); }); });
    render(true);

    if (!form) return;
    form.addEventListener('submit', function (e) {
      /* KACHING OWNS THE SUBMIT WHEN A DEAL BLOCK IS ON THE PAGE.

         This handler posts one line - the selected variant, quantity one -
         which is the right payload for a product with no offer and the wrong
         one for a bundle. Measured on the draft: with "Buy 2, Get 1 FREE"
         selected and showing $66.30, the cart received a single $39 ring,
         because this listener called preventDefault and did its own fetch
         before the app could see the event.

         Standing aside is the whole fix. The app binds its own handling to the
         product form, so not intercepting is what lets the complete selection -
         every product, variant, quantity and property the offer carries - be
         submitted by the system that knows what it is. */
      /* NOT standing aside. Tried that: without preventDefault the browser
         does a native POST of the theme's own id and quantity=1, and the cart
         receives one ring. The app does not listen for the submit - it has no
         button of its own here and binds nothing to this form - so letting the
         event through is letting the wrong payload go.

         The theme's own fetch is kept instead, and the app's hidden
         properties[__kaching_bundles] input rides along with it, because the
         collector below reads every properties[...] field off the form. */
      if (!window.fetch) return;
      e.preventDefault();
      var btns = section.querySelectorAll('[data-calmy-atc]');
      var err = section.querySelector('[data-calmy-error]');
      if (err) err.classList.remove('is-on');
      btns.forEach(function (b) { b.disabled = true; });

      /* Collect the line item properties from the form.

         The handler used to post only the id and the quantity, which quietly
         dropped anything carried as properties[...] - the engraving reached the
         input and went no further. Reading them off the form means any property
         added later travels without this code changing again.

         Disabled inputs are skipped by design: the engraving field disables
         itself while empty so that no blank "Engraving:" line lands on an order
         that did not ask for one. */
      /* THE WHOLE FORM GOES, NOT A HAND-BUILT PAYLOAD.

         This used to assemble { id, quantity, properties } by hand and post it
         as JSON. Everything that was not an id, a quantity or a properties[...]
         field was silently dropped - and the bundles app carries its selected
         tier in a field of its own, named kaching-bundles-deal-<id>. So the app
         saw a plain one-unit add with no tier attached and had nothing to
         expand: choosing "Buy 3, Get 2 FREE" put ONE ring in the cart at full
         price. Measured on the storefront, all three tiers behaved that way.

         FormData takes the form exactly as the customer left it, so the tier
         field, the engraving, the bundle property and any field added later all
         travel without this code needing to know about them. Disabled inputs
         are omitted by FormData itself, which is the behaviour the engraving
         field already relied on.

         Still fetch, and still /cart/add.js: the app patches window.fetch to
         intercept the add, so the request has to go through fetch for the
         bundle to be expanded at all. */
      var payload = new FormData(form);
      payload.set('id', idInput.value);
      payload.set('quantity', currentQty());

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          btns.forEach(function (b) { b.disabled = false; });
          if (!res.ok) {
            if (err) {
              err.textContent = res.body.description || res.body.message || CT('pdp_add_failed', 'This item could not be added to the cart.');
              err.classList.add('is-on');
            }
            return;
          }
          if (window.Calmy && window.Calmy.refreshCart) {
            window.Calmy.refreshCart(true);
          } else {
            section.classList.add('is-added');
          }
        })
        .catch(function () {
          btns.forEach(function (b) { b.disabled = false; });
          if (err) { err.textContent = CT('pdp_network_error', 'Network error. Please try again.'); err.classList.add('is-on'); }
        });
    });
  }

  /* Sticky bar: only after the real button has left the top of the screen, and never once
     the newsletter or footer is in view. */
  function initSticky(section) {
    var bar = section.querySelector('[data-calmy-sticky]');
    var anchor = section.querySelector('[data-calmy-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var passedAtc = false, atEnd = false;
    function sync() { bar.classList.toggle('is-on', passedAtc && !atEnd); }

    /* Default root, no margin.

       This used to shrink the root with rootMargin '0px 0px -100% 0px', which
       collapses it to zero height - nothing ever intersects, so the observer
       fired once on setup and never again and the bar stayed hidden the whole
       way down the page. Watching the anchor against the real viewport gives a
       callback each time it enters or leaves, which is what the toggle needs. */
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { passedAtc = !en.isIntersecting && en.boundingClientRect.top < 0; });
      sync();
    }, { threshold: 0 }).observe(anchor);
    /* Watch every tail landmark, not the first one found.

       Picking only .cnl left the bar sitting over the footer, because at the
       very bottom of a long page the newsletter has already scrolled above the
       fold and the footer is what fills the screen. atEnd is true when any of
       them is in view. */
    var tails = document.querySelectorAll('.cnl, .cfoot, .cfootref, footer');
    if (tails.length) {
      var seen = new WeakSet();
      var tailObs = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target);
        });
        atEnd = Array.prototype.some.call(tails, function (t) { return seen.has(t); });
        sync();
      }, { threshold: 0 });
      tails.forEach(function (t) { tailObs.observe(t); });
    }
  }

  function initSizeGuide(section) {
    var dlg = section.querySelector('[data-calmy-sizeguide]');
    if (!dlg) return;
    document.querySelectorAll('[data-calmy-sizeguide-open]').forEach(function (b) {
      if (b.__calmySG) return;
      b.__calmySG = true;
      b.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    });
    dlg.querySelectorAll('[data-calmy-sizeguide-close]').forEach(function (b) {
      b.addEventListener('click', function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); });
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
  }

  /* One informational accordion open at a time. */
  function initAccordions() {
    document.querySelectorAll('.cacc').forEach(function (group) {
      if (group.__calmyAcc) return;
      group.__calmyAcc = true;
      var items = group.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-calmy-product]').forEach(function (section) {
      if (section.__calmyReady) return;
      section.__calmyReady = true;
      var g = section.querySelector('[data-cgal]');
      if (g) initGallery(g);
      initProduct(section);
      initSticky(section);
      initSizeGuide(section);
    });
    initAccordions();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/**
 * Gallery video: inline and muted by default, but not unconditionally.
 *
 * Autoplay is set in the markup so the first frame moves without waiting for
 * JS. Here we take it back in the two cases where it is wrong: the visitor
 * prefers reduced motion, in which case the video pauses and gets its controls
 * back so it is still watchable on purpose; and the frame being off-screen,
 * where a looping video is pure battery cost.
 */
(function () {
  var vids = document.querySelectorAll("[data-cgal-video] video");
  if (!vids.length) return;

  var still = window.matchMedia("(prefers-reduced-motion: reduce)");

  function apply() {
    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute("playsinline", "");
      if (still.matches) {
        v.pause();
        v.controls = true;
        v.autoplay = false;
      } else {
        v.controls = false;
      }
    });
  }
  apply();
  if (still.addEventListener) still.addEventListener("change", apply);

  if (!("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (still.matches) return;
        if (e.isIntersecting) {
          var play = v.play();
          if (play && play.catch) play.catch(function () {});
        } else {
          v.pause();
        }
      });
    },
    { threshold: 0.25 }
  );
  vids.forEach(function (v) { io.observe(v); });
})();

/**
 * Finish tone filters.
 *
 * THE DESCRIPTOR SYNC IS GONE. A syncDesc() used to run here on every change of
 * a finish radio, reading that option's data-desc and writing it into the line
 * under the swatches. Both the line and the attribute have been removed from
 * calmy-variant-picker.liquid, so it had nothing to read and nothing to write
 * to - and leaving it in place would have been the one thing still able to put
 * the text back when the selected variant changed.
 *
 * The tone filter hides swatches rather than dimming them, so the row closes
 * up. It never hides the checked one - filtering away the current selection
 * would leave the page claiming a finish nothing on screen agrees with.
 */
(function () {
  var scope = document.querySelector("[data-calmy-product]");
  if (!scope) return;

  scope.querySelectorAll("[data-calmy-tones]").forEach(function (bar) {
    var oi = bar.getAttribute("data-calmy-tones");
    var inputs = scope.querySelectorAll('input[data-calmy-opt="' + oi + '"]');
    var btns = bar.querySelectorAll(".cvar__tone");

    bar.addEventListener("click", function (e) {
      var b = e.target.closest(".cvar__tone");
      if (!b) return;
      var want = b.getAttribute("data-tone");

      btns.forEach(function (x) { x.classList.toggle("is-active", x === b); });
      inputs.forEach(function (i) {
        var hide = want !== "all" && i.getAttribute("data-tone") !== want && !i.checked;
        i.classList.toggle("is-filtered", hide);
      });
    });
  });
})();

/* THE GALLERY MOVED TO assets/calmy-gallery.js.

   A second gallery used to live here: it bound to the same
   [data-cgal-item] nodes, kept its own index, and set is-active on
   them. With the rebuilt markup both scripts matched the same
   elements and both answered a variant change - measured on the draft,
   the desktop column marked tile 0 active while the selected finish
   was tile 2. One owner now.

   The variant picker below still calls gallery.__goToMedia(); that
   function is provided by calmy-gallery.js. */


/**
 * Keeps the sticky bar's finish swatches and the main picker in step.
 *
 * They cannot share a radio group: the main picker's inputs live inside the
 * product form and the bar's do not, so the browser treats them as two
 * unrelated groups and checking one leaves the other showing a stale choice.
 * This mirrors the selection both ways.
 *
 * The mirrored input is set directly rather than clicked, and no synthetic
 * change event is dispatched from inside the handler - the existing variant
 * logic already ran for the real interaction, and re-firing would put the two
 * groups in a loop.
 */
(function () {
  "use strict";

  var scope = document.querySelector("[data-calmy-product]");
  if (!scope) return;

  /* Capture phase, deliberately.

     The variant logic reads every [data-calmy-opt] input on the page and lets
     the last checked one win, and the sticky bar's inputs come after the main
     picker's in the DOM. Mirroring on bubble meant that choosing Silver in the
     main picker rendered while the bar still said Gold, so the bar silently
     overrode the click that had just been made. A capture listener on the same
     node runs before the bubble listeners on it, so both groups already agree
     by the time anything reads them. */
  scope.addEventListener("change", function (e) {
    var src = e.target;
    if (!src || !src.matches || !src.matches("input[data-calmy-opt]")) return;

    var oi = src.getAttribute("data-calmy-opt");
    scope.querySelectorAll('input[data-calmy-opt="' + oi + '"]').forEach(function (other) {
      if (other === src) return;
      if (other.name === src.name) return; // same group, browser handled it
      other.checked = other.value === src.value;
    });
  }, true);
})();

/**
 * Engraving: a live character count, and no empty property on the order.
 *
 * Shopify keeps a line item property that is present but blank, which would put
 * an empty "Engraving:" line on every order that did not ask for one. Disabling
 * the input while it is empty means it is not submitted at all - and it is
 * re-enabled the moment anything is typed, so the field itself never appears
 * disabled to the customer.
 */
(function () {
  "use strict";

  var box = document.querySelector("[data-calmy-engraving]");
  if (!box) return;

  var input = box.querySelector("[data-calmy-engraving-input]");
  var count = box.querySelector("[data-calmy-engraving-count]");
  if (!input) return;

  var max = parseInt(input.getAttribute("maxlength"), 10) || 20;

  function sync() {
    var n = input.value.length;
    if (count) count.textContent = n + "/" + max;
    input.disabled = input.value.trim() === "";
  }

  // Disabled inputs do not fire input events, so the listener sits on the box.
  box.addEventListener("input", sync);
  box.addEventListener("pointerdown", function () {
    if (input.disabled) { input.disabled = false; input.focus(); }
  });
  box.addEventListener("focusin", function () {
    if (input.disabled) input.disabled = false;
  });
  input.addEventListener("blur", sync);

  sync();
})();

/**
 * Copy-to-clipboard for a discount code.
 *
 * The button's own label is the code, so if the clipboard API is unavailable or
 * refused - insecure context, permission denied, an older browser - the visitor
 * has lost nothing: the code is still right there to read and type. That is why
 * this never shows an error state.
 */
(function () {
  "use strict";

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-calmy-copy]");
    if (!btn) return;

    var code = btn.getAttribute("data-calmy-copy");
    var done = btn.getAttribute("data-copied") || "Copied";
    var original = btn.dataset.original || btn.textContent;
    btn.dataset.original = original;

    function confirm() {
      btn.textContent = done;
      btn.classList.add("is-copied");
      window.setTimeout(function () {
        btn.textContent = btn.dataset.original;
        btn.classList.remove("is-copied");
      }, 1800);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(confirm, function () {});
      return;
    }

    /* Fallback for insecure contexts, where navigator.clipboard is undefined. */
    try {
      var t = document.createElement("textarea");
      t.value = code;
      t.setAttribute("readonly", "");
      t.style.cssText = "position:fixed;top:-1000px;opacity:0";
      document.body.appendChild(t);
      t.select();
      document.execCommand("copy");
      document.body.removeChild(t);
      confirm();
    } catch (err) {
      /* Leave the code on screen to be read. */
    }
  });
})();
